import { Component, ElementRef, TemplateRef, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { DatePipe } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatOption } from '@angular/material/core';
export interface PopupData {
  title: string;
}
interface DropDownInterface {
  codelistCode: any;
  codelistName: any;
}
@Component({
  selector: 'app-tms-user-training-review-period',
  templateUrl: './tms-user-training-review-period.component.html',
  styleUrls: ['./tms-user-training-review-period.component.scss']
})
export class TmsUserTrainingReviewPeriodComponent implements OnInit, OnDestroy {
  popupData: PopupData = {
    title: ''
  };
  dateCustomClasses: DatepickerDateCustomClasses[];
  getUserPriodData: any = {};
  isProcessing = false;
  searchByPeriodId = [];
  getLmsTrainingReviewPeriodVwDetailsTableData: any = [];
  fromDate: any;
  toDate: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  pdfDetailSearchText: string = '';
  private isNavigatingToEdit: boolean = false;
  searchUserName: any;
  reviewPeriodId: any;
  reviewPeriodName: any;
  isFixedPeriod = true;
  childGridShow: any;
  snackbarRef: any;
  participantUserName: string;
  pager: any = {};
  pagedItems: any[];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  periodSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  constructor(public appService: AppService, public router: Router, public service: messageService, public dialog: MatDialog,
    public snackBar: MatSnackBar, public paginationService: PaginationService, public message: messageService, public elem: ElementRef, public datePipe: DatePipe) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  periodValueDropdown: any;
  selectBoxeForPeriodValue() {
    this.periodValueDropdown = this.getLmsTrainingReviewPeriodVwDetailsTableData
      .filter((item: { isActive: string; }) => item.isActive !== 'N')
      .map((item: { reviewPeriodId: any; reviewPeriodName: any; }) => ({
        valueExp: item.reviewPeriodId,
        displayExp: item.reviewPeriodName
      }));
  }
  getLmsTrainingReviewPeriodVwDetailsEditData: any = {};
  onPeriodSelectnew(event: any, item: any) {
    console.log("event.isUserInput=", event.isUserInput);

    if (event.isUserInput) {
      this.isProcessing = true;

      if (item === null) {

        this.isProcessing = false;
        this.childGridShow = false;
        console.log("Un-selected period");
      } else {

        this.message.chosenPeriod = item.valueExp;
        this.appService.getLmsTrainingReviewPeriodVwDetailsByReviewPeriodId(
          item.valueExp).subscribe({
            next: (response: any) => {
              this.getLmsTrainingReviewPeriodVwDetailsEditData = response;
              this.reviewPeriodId = this.message.reviewPeriodId = this.getLmsTrainingReviewPeriodVwDetailsEditData.reviewPeriodId;
              this.reviewPeriodName = this.message.reviewPeriodName = this.getLmsTrainingReviewPeriodVwDetailsEditData.reviewPeriodName;
              this.message.reviewPeriodDescription = this.getLmsTrainingReviewPeriodVwDetailsEditData.reviewPeriodDescription;
              this.isFixedPeriod = this.getLmsTrainingReviewPeriodVwDetailsEditData.isFixedPeriod === 'Y';

              this.fromDate = this.getLmsTrainingReviewPeriodVwDetailsEditData.fromDate
                ? new Date(this.getLmsTrainingReviewPeriodVwDetailsEditData.fromDate.split('T'))
                : null;
              this.toDate = this.getLmsTrainingReviewPeriodVwDetailsEditData.toDate
                ? new Date(this.getLmsTrainingReviewPeriodVwDetailsEditData.toDate.split('T'))
                : null;

              this.childGridShow = true; // Show the grid when a valid period is selected
              this.getUserPriod(this.reviewPeriodId);
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
            }
          });
      }
    }
  }


  getUserPriod(reviewPeriodId: any) {
    this.isProcessing = true;
    this.appService.getUserPriodList(reviewPeriodId).subscribe({
      next: (data: any) => {
        this.getUserPriodData = data;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.getUserPriodData.length;
        this.totalPages = Math.ceil(this.getUserPriodData.length / this.itemsPerPage);
        this.setPage1(1, 0);
        this.columnList = "User Name,From Date,To Date,Comments,Review Status,Reviewed On,Reviewed By";
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });
  }
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  getUserPriodDataForDelete: any = {};
  openDeletePopup(getUserPriodDatas: any) {
    this.getUserPriodDataForDelete = getUserPriodDatas;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  deleteFieldValue: any;
  deleteFieldValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFieldValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    this.deleteFieldValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFieldValue.value == '') {
      this.isProcessing = false;
      this.deleteFieldValue.style.border = '1px solid red';
      this.deleteFieldValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFieldValue.style.border = 'none';
      this.deleteFieldValueRequiredMsg.style.display = 'none';
    }
  }
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  deleteFunction() {
    this.isProcessing = true;
    if (this.getUserPriodDataForDelete.deleteReason == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {

      this.appService.deleteUserPriod(this.getUserPriodDataForDelete).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.getUserPriod(this.reviewPeriodId);
            this.visibleDeletePopup.close();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }
  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  getUserStatusDetails(userId: any, reviewPeriodId: any) {
    this.message.reviewPeriodIdVal = reviewPeriodId;
    this.message.userIdVal = userId;
    this.isNavigatingToEdit = true;
    this.router.navigate(['/dashboard/TmsUserTrainingReviewPeriodEditComponent']);
  }
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY'
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  //open popup for add user in review period
  @ViewChild('addUserPopup', { static: true }) addUserPopup: TemplateRef<any>;
  visibleAddUserPopup: MatDialogRef<TemplateRef<any>>;
  searchAddUserPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  openAddPopup() {
    this.popupData.title = "Add User(S)";
    this.searchUserName = "";
    this.searchUserId = null;
    this.noUserAlert = false;
    this.showUserSearchGrid = false;
    this.visibleAddUserPopup = this.dialog.open(this.addUserPopup, this.searchAddUserPopupConfig);
  }
  cancelAddUserPopupFunction() {
    this.visibleAddUserPopup.close();
  }
  multiUsersArray: any = [];
  getUsersDetails() {
    if (!this.fromDate) {
      alert('Please add From Date ');
    } else if (!this.toDate) {
      alert('Please add To Date ');
    } else if (this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
      alert('To Date cannot be before From Date');
    } else if (this.multiUsersArray.length < 1) {
      this.noUserAlert = true;
    } else {
      for (let k = 0; k < this.multiUsersArray.length; k++) {
        const data = {
          reviewPeriodId: this.reviewPeriodId,
          fromDate: this.appService.dateZoneConvertion(new Date(this.fromDate)),
          toDate: this.appService.dateZoneConvertion(new Date(this.toDate)),
          userId: this.multiUsersArray[k].userId,
          comments: "",
          reviewStatus: "Pending",
          deleteReason: ""
        };
        this.isProcessing = true;
        this.appService.addUserForReview(data).subscribe({
          next: (response: any) => {
            console.log(response, k);
            this.displayMessage = response.result;
            this.displayResultType = response.resultType;
            this.getUserPriod(this.reviewPeriodId);
            this.visibleAddUserPopup.close();
            this.isProcessing = false;
            this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 5000 : undefined,
              data: {
                message: response.result,
                type: response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: response.resultType == 'S' ? 'Success' : 'Error',
            });
            this.snackbarRef.onAction().subscribe(() => {
              this.snackbarRef.dismiss();
            });
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }
  //search user
  showUserSearchGrid: boolean;
  noUserAlert: boolean = false;
  showInstructorTrainingSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any = null;
  departmentCodeValue: any = null;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetails: any = [];
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  dealingWith: any = false;
  selectedOption: any;
  communicationData: any = {};
  searchUserId: any;
  chosenToUserId = [];
  chosenToUserName: any;
  searchByDepartmentCodeMain = [];
  myTeam: any = false;

  @ViewChild('searchUserPopup', { static: true }) searchUserPopup: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  searchUserPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  designationListDropdown: any = [];
  departmentListDropdown: any = [];
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];

  selectBoxForDesignation() {
    this.designationListDropdown = [];
    this.designationListDropdown = this.dropDownForDesignation.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  openSearchUserPopup(value: any) {
    this.dealingWith = value;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.multiUsersArray = [];
    this.chosenToUserName = null;
    this.searchUserIdForManagerselection = this.message.getUserId();
    this.searchUserNameForManagerselection = localStorage.getItem("userprofilename");
    [this.searchByDesignationCode, this.searchByDepartmentCode, this.chosenToUserId, this.chosenToUserName] = [null, null, [], []];
    this.popupData.title = "Search User(s)";
    this.visibleSearchUserPopup = this.dialog.open(this.searchUserPopup, this.searchUserPopupConfig);
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  selectAllUsersChanged(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getOneQmsUsersVwDetails.every((user: any) => {
        if (user.emailAddress) {
          user.searchUserChildCheckBox = true;
          this.multiUsersArray.push({ userId: user.userId, userName: user.userName });
        }
        return true;
      })
    } else {
      this.multiUsersArray = [];
      this.getOneQmsUsersVwDetails.every((user: any) => {
        if (user.emailAddress) { user.searchUserChildCheckBox = false; } return true;
      })
    }
  }

  onChildCheckBoxChanged(e: any, user: any, idx: any) {
    if (e.target.checked) {
      user.searchUserChildCheckBox = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.userId === user.userId)) {
        this.multiUsersArray.push({ userId: user.userId, userName: user.userName });
      }
      this.getOneQmsUsersVwDetails.every((allUsers: any) => { if (allUsers.searchUserChildCheckBox) { this.searchUserParentCheckBox = true; } return true; })
    } else {
      user.searchUserChildCheckBox = false;
      const removal = this.getOneQmsUsersVwDetails.findIndex((removableUser: any) => removableUser.userId == user.userId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);

      if (this.getOneQmsUsersVwDetails.some((allUsers: any) => !allUsers.searchUserChildCheckBox)) {
        this.searchUserParentCheckBox = false;
      }
    }
    console.log(this.multiUsersArray, "this.qmsUsersList");
  }
  searchUser() {
    this.isProcessing = true;
    if (this.searchByDesignationCode) {
      this.designationCodeValue = this.searchByDesignationCode;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode) {
      this.departmentCodeValue = this.searchByDepartmentCode;
    } else {
      this.departmentCodeValue = null;
    }

    this.searchOneQmsUserVwDetails = {
      userName: this.searchByUserName || '',
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      managerId: this.searchUserIdForManagerselection ? this.searchUserIdForManagerselection.toString() : null,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetailsByManagerId(this.searchOneQmsUserVwDetails).subscribe((data: any) => {
      this.getOneQmsUsersVwDetails = data;
      this.searchUserParentCheckBox = false;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchUserNameForManagerselection = null;
    this.searchUserIdForManagerselection = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetails = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  setUser() {
    this.searchUserName = this.multiUsersArray.map((user: any) => user.userName).join(',');
    if (this.searchUserName != "" && this.searchUserName != null && this.searchUserName != undefined) {
      this.visibleSearchUserPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  cancelSearchManagerFunction() {
    this.visibleSearchUserPopup.close();
  }
  showMyTeamSearch(e: any) {
    if (e.target.checked) {
      this.myTeam = true;
    } else {
      this.myTeam = false;
    }
  }
  //Manager search
  showUserSearchGridForManagerselection: boolean;
  searchByUserNameForManagerselection: any = null;
  searchByFirstNameForManagerselection: any = null;
  searchByLastNameForManagerselection: any = null;
  searchByDesignationCodeForManagerselection: any = [];
  searchByDepartmentCodeForManagerselection: any = [];
  searchingByStatusCodeForManagerselection: any = [];
  designationCodeValueForManagerselection: any;
  departmentCodeValueForManagerselection: any;
  statusCodeValueForManagerselection: any;
  searchOneQmsUserVwDetailsForManagerselection: any;
  getOneQmsUsersVwDetailsForManagerselection: any = [];
  searchUserParentCheckBoxForManagerselection: boolean = false;
  currentIndexForManagerselection: any;
  previousIndexForManagerselection: any = null;
  dealingWithForManagerselection: any = false;
  selectedOptionForManagerselection: any;
  communicationDataForManagerselection: any = {};
  searchUserIdForManagerselection: any;
  chosenToUserIdForManagerselection: any;
  chosenToUserNameForManagerselection: any;
  searchUserNameForManagerselection: any;
  @ViewChild('searchManagerPopup', { static: true }) searchManagerPopup: TemplateRef<any>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  searchManagerPopupConfigForManagerselection = {
    width: '70%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '30px' },
  };
  designationListDropdownForManagerselection: any = null;
  departmentListDropdownForManagerselection: any = null;
  selectedDesignationValueForManagerselection: any;
  selectedDepartmentValueForManagerselection: any;
  dropDownForDesignationForManagerselection: any = [];
  dropDownForDepartmentForManagerselection: any = [];
  selectBoxForDesignationForManagerselection() {
    this.designationListDropdownForManagerselection = [];
    this.designationListDropdownForManagerselection = this.dropDownForDesignation.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  selectBoxForDepartmentForManagerselection() {
    this.departmentListDropdownForManagerselection = [];
    this.departmentListDropdownForManagerselection = this.dropDownForDepartment.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  openSearchMangerPopup() {
    this.searchUserNameForManagerselection = "";
    this.showUserSearchGridForManagerselection = false;
    this.searchByUserNameForManagerselection = null;
    this.searchByFirstNameForManagerselection = null;
    this.searchByLastNameForManagerselection = null;
    [this.searchByDesignationCodeForManagerselection, this.searchByDepartmentCodeForManagerselection, this.chosenToUserIdForManagerselection, this.chosenToUserNameForManagerselection] = [null, null, [], []];
    this.popupData.title = "Search Manager(s)";
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManagerPopup, this.searchManagerPopupConfigForManagerselection);
  }
  onChildCheckBoxChangedForManagerselection(e: any, listOfUsersData: any, idx: any) {
    if (e.target.checked) {
      listOfUsersData.searchUserChildCheckBox = true;
      this.chosenToUserIdForManagerselection = listOfUsersData.userId;
      this.chosenToUserNameForManagerselection = listOfUsersData.userName;
    }
  }
  searchUserForManagerselection() {
    this.isProcessing = true;
    if (this.searchByDesignationCodeForManagerselection) {
      this.designationCodeValueForManagerselection = this.searchByDesignationCodeForManagerselection;
    } else {
      this.designationCodeValueForManagerselection = null;
    }
    if (this.searchByDepartmentCodeForManagerselection) {
      this.departmentCodeValueForManagerselection = this.searchByDepartmentCodeForManagerselection;
    } else {
      this.departmentCodeValueForManagerselection = null;
    }
    this.searchByUserNameForManagerselection = this.searchByUserNameForManagerselection || '';
    this.searchOneQmsUserVwDetailsForManagerselection = {
      userName: this.searchByUserNameForManagerselection,
      firstName: this.searchByFirstNameForManagerselection,
      lastName: this.searchByLastNameForManagerselection,
      designationCode: this.designationCodeValueForManagerselection,
      departmentCode: this.departmentCodeValueForManagerselection,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetailsForManagerselection).subscribe((data: any) => {
      this.getOneQmsUsersVwDetailsForManagerselection = data;
      this.searchUserParentCheckBoxForManagerselection = false;
      this.showUserSearchGrid = true;
      this.showUserSearchGridForManagerselection = true;
      this.isProcessing = false;
    })
  }
  resetSearchManagerGridDataForManagerselectionFunction() {
    this.isProcessing = true;
    this.searchByUserNameForManagerselection = null;
    this.searchByFirstNameForManagerselection = null;
    this.searchByLastNameForManagerselection = null;
    this.searchByDesignationCodeForManagerselection = null;
    this.searchByDepartmentCodeForManagerselection = null;
    this.getOneQmsUsersVwDetailsForManagerselection = [];
    this.showUserSearchGridForManagerselection = false;
    this.isProcessing = false;
  }
  setUserForManagerselection() {
    this.searchUserIdForManagerselection = this.chosenToUserIdForManagerselection;
    this.searchUserNameForManagerselection = this.chosenToUserNameForManagerselection;
    if (this.searchUserNameForManagerselection != "" && this.searchUserNameForManagerselection != null && this.searchUserNameForManagerselection != undefined) {
      this.visibleSearchManagerPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  cancelSearchManagerForManagerselectionFunction() {
    this.visibleSearchManagerPopup.close();
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.getUserPriodData.length, page, this.perPage, targetpage);
    if (this.getUserPriodData.length > 0) {
      this.pagedItems = this.getUserPriodData.length ? this.getUserPriodData.slice(this.pager.startIndex, this.pager.endIndex + 1) : [];
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  //Excell & PDF
  whereValsForExcel: any;
  whereValsForExcelTemp: any;
  auditTrailsFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.getUserPriodData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.getUserPriodData.filter((item: any) => {
        const columnValue = item[column];

        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }
  generateReport(value: any) {
    console.log("genRep");
    let tname = "";
    let colList = "";
    let fieldList = "";
    let orderBy = "";
    if (this.auditTrailsFlag == 0) {
      this.whereValsForExcel = "";
      tname = "TMS_USER_TRAINING_REVIEW_PERIOD_VW";
      colList = "USER_NAME,FROM_DATE,TO_DATE,COMMENTS,REVIEW_STATUS,REVIEWED_ON,REVIEW_USER";
      fieldList = "User Name,From Date,To Date,Comments,Review Status,Reviewed On,Reviewed By";
      this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND REVIEW_PERIOD_ID=" + this.reviewPeriodId;
    } else {
      orderBy = "CREATED_TS";
      tname = this.tableOrViewNameForAuditTrails;
      colList = this.columnListAuditTrails1;
      fieldList = this.fieldLabelsListForAuditTrails;
    }
    console.log(value, "--------------------");
    const data = {

      groupId: null
    }
    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: orderBy,
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: this.statusCodeValue,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      logoId: 0,
      module: "TRN",
      footer: this.selectedReportFooter,
      isSaveRep: 'N',
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }
    this.reportObj = { ...data1, ...data };
    debugger;
    if (value == 'Excel') {
      const pdfData = {
        ...this.reportObj, title: "User Review", columns: [],
        "informationTab": {
          "Report Name": "User Review",
          "Exported By": localStorage.getItem("loggedUserName")
        }
      }
      this.appService.downloadexcelForChart(pdfData, "User_Review.xlsx");
    } else {
      const pdfData = {
        ...this.reportObj, logoId: 0, title: "User Review", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(',')
      }
      this.appService.downloadPdfForChart(pdfData, "User_Review.pdf");
    }
  }

  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  pdfSearchText: string = '';
  @Input() excelPdf: any = {};
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange1(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  openReportPopup(item: any) {
    this.auditTrailsFlag = 0
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }
  //end excell & pdf

  //audit trails
  searchValue: any;
  whereClause: any;
  columnListAuditTrails: any;
  columnListAuditTrails1: any;
  fiveColumnForAuditTrails: any;
  spColumnForAuditTrails: any;
  fiveFieldLabelsColumnForAuditTrails: any;
  spFieldLabelsColumnForAuditTrails: any;
  fieldLabelsListForAuditTrails: any;
  tableOrViewNameForAuditTrails: any;
  columnListsAuditTrails: any = {};
  dataTypeList: any = [];
  listForAuditTrails: any = [];
  makeStickyColumns: any;
  collectionSizeForAudtitrails: number;
  perPageForAudtitrails = 10;
  calculateTotalPagesForAudtitrails: number;
  pagerForAudtitrails: any = {};
  pagedItemsForAudtitrails: any[];
  @ViewChild('auditTrailPopup', { static: true }) auditTrailPopup: TemplateRef<any>;
  visibleAuditTrailPopup: MatDialogRef<TemplateRef<any>>;
  //end audit trails
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1)
        this.selectBoxForFooter();
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("TRN")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }

  ngOnInit() {
    this.isProcessing = true;

    // 1. Load the dropdown values
    this.searchByPeriodId = this.message.chosenPeriod ? this.message.chosenPeriod : [];
    this.appService.getLmsTrainingReviewPeriodVwDetails().subscribe((response: any) => {
      this.getLmsTrainingReviewPeriodVwDetailsTableData = response;
      this.selectBoxeForPeriodValue();
      this.isProcessing = false;
    });
    if (this.message.chosenPeriod) {
      this.isProcessing = true;
      this.appService.getLmsTrainingReviewPeriodVwDetailsByReviewPeriodId(this.message.chosenPeriod).subscribe({
        next: (response: any) => {
          this.getLmsTrainingReviewPeriodVwDetailsEditData = response;
          this.reviewPeriodId = this.message.reviewPeriodId = this.getLmsTrainingReviewPeriodVwDetailsEditData.reviewPeriodId;
          this.reviewPeriodName = this.message.reviewPeriodName = this.getLmsTrainingReviewPeriodVwDetailsEditData.reviewPeriodName;
          this.message.reviewPeriodDescription = this.getLmsTrainingReviewPeriodVwDetailsEditData.reviewPeriodDescription;
          this.isFixedPeriod = this.getLmsTrainingReviewPeriodVwDetailsEditData.isFixedPeriod === 'Y';

          if (this.getLmsTrainingReviewPeriodVwDetailsEditData.fromDate) {
            this.fromDate = new Date(this.getLmsTrainingReviewPeriodVwDetailsEditData.fromDate.split('T'));
          } else {
            this.fromDate = null;
          }

          if (this.getLmsTrainingReviewPeriodVwDetailsEditData.toDate) {
            this.toDate = new Date(this.getLmsTrainingReviewPeriodVwDetailsEditData.toDate.split('T'));
          } else {
            this.toDate = null;
          }

          // Show the grid and fetch the users
          this.childGridShow = true;
          this.getUserPriod(this.reviewPeriodId);
          this.isProcessing = false;
        },
        error: (error) => {
          console.error("Failed to restore grid data", error);
          this.isProcessing = false;
        }
      });
    }
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();
    this.selectBoxForDepartmentForManagerselection();
    this.selectBoxForDesignationForManagerselection();
    this.ngOnChangesReportFooter();
  }

  ngOnDestroy(): void {
    // If we are NOT going to the edit page, burn the data.
    if (!this.isNavigatingToEdit) {
      this.message.chosenPeriod = null;
      this.message.reviewPeriodId = null;
      this.message.reviewPeriodName = null;
      this.message.reviewPeriodDescription = null;
      this.message.userIdVal = null;
      this.message.reviewPeriodIdVal = null;
    }
  }
  auditTrail: any = {};
  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  openAuditTrail(viewType: any, userTrainingReview: any) {
    console.log(userTrainingReview.reviewPeriodId, "=userTrainingReview.reviewPeriodId");
    console.log(this.message.chosenPeriod, "=this.message.chosenPeriod");
    console.log(viewType, "=viewType");
    console.log(userTrainingReview, "=userTrainingReview")
    this.message.tableOrView_Name = "TMS_USER_TRAINING_REVIEW_PERIOD_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,USER_NAME,USER_FULLNAME,FROM_DATE,TO_DATE,COMMENTS,REVIEW_STATUS,REVIEW_USER,REVIEWED_ON,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,User Name,User Full Name,From Date,To Date,Comments,Review User,Reviewed By,Reviewed On,Deleted By,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? " AND REVIEW_PERIOD_ID = " + this.message.chosenPeriod : " AND REVIEW_PERIOD_ID = " + userTrainingReview.reviewPeriodId + " AND USER_ID = " + userTrainingReview.userId
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,User Name,User Full Name,From Date,To Date,Comments,Review Status,Reviewed By,Reviewed On,Review User,Deleted By,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? " WHERE REVIEW_PERIOD_ID = " + this.message.chosenPeriod : " WHERE REVIEW_PERIOD_ID=" + userTrainingReview.reviewPeriodId + " AND USER_ID=" + userTrainingReview.userId;
    this.message.report_And_Popup_Name = "User Training Review Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(userTrainingReview);
  }
}
